import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { StatusBar } from "../components/Shell";
import Ico from "../components/Ico";
import { useAppStore } from "../components/AppStore";
import { masterJobs, categories, currentNeighbor } from "../mock";
import { ChevronLeft, ShieldCheck, CheckCircle2, Lightbulb, X } from "lucide-react";

export default function PostJob() {
  const navigate = useNavigate();
  const { postJob } = useAppStore();
  const [form, setForm] = useState({
    title: "", category: "Outdoor", icon: "Trees", tint: "#4fae3f",
    pay: "", duration: "1 hr", distance: "0.2 mi", schedule: "", desc: "",
  });
  const [posted, setPosted] = useState(false);

  const pickSuggestion = (s) =>
    setForm((f) => ({ ...f, title: s.title, category: s.category, icon: s.icon, tint: s.tint, pay: String(s.pay) }));

  const canPost = form.title && form.pay && form.schedule;

  const submit = () => {
    if (!canPost) return;
    postJob({ ...form, pay: Number(form.pay), xp: 250, poster: currentNeighbor.id });
    setPosted(true);
  };

  return (
    <div className="gd-screen bg-[#eef1fb]">
      <div className="flex-shrink-0 px-5 pb-5" style={{ background: "linear-gradient(160deg,#f5a63a,#e97f0c)", borderBottomLeftRadius: 28, borderBottomRightRadius: 28 }}>
        <StatusBar dark={false} />
        <div className="mt-1 flex items-center gap-2">
          <button onClick={() => navigate(-1)} className="gd-tap grid h-10 w-10 place-items-center rounded-full bg-white/20"><ChevronLeft size={20} color="#fff" /></button>
          <h1 className="text-2xl font-extrabold text-white">Post a Job</h1>
        </div>
      </div>

      <div className="gd-scroll px-4 pb-28 gd-stagger">
        <div className="mt-4 flex items-center gap-2 rounded-2xl bg-[#eaf6ea] p-3 text-[12px] font-semibold text-[#2e7d27]">
          <ShieldCheck size={16} /> You're background-check verified, so you can post jobs for kids.
        </div>

        {/* master suggested job list */}
        <div className="mb-2 mt-5 flex items-center gap-2">
          <Lightbulb size={16} className="text-[#f5911e]" />
          <h3 className="text-sm font-extrabold text-[#1f2a52]">Ideas — what kids can do</h3>
        </div>
        <div className="flex gap-2.5 overflow-x-auto pb-2" style={{ scrollbarWidth: "none" }}>
          {masterJobs.map((s) => (
            <button key={s.title} onClick={() => pickSuggestion(s)}
              className="gd-tap flex w-24 flex-shrink-0 flex-col items-center gap-1.5 rounded-2xl bg-white p-3 shadow-[0_6px_18px_rgba(31,42,82,0.06)]"
              style={{ outline: form.title === s.title ? `2px solid ${s.tint}` : "none" }}>
              <div className="grid h-11 w-11 place-items-center rounded-2xl" style={{ background: `${s.tint}18` }}><Ico name={s.icon} size={20} color={s.tint} /></div>
              <span className="text-center text-[10px] font-bold leading-tight text-[#5b648a]">{s.title}</span>
              <span className="text-[10px] font-extrabold text-[#4fae3f]">${s.pay}</span>
            </button>
          ))}
        </div>

        {/* form */}
        <div className="gd-card mt-4 space-y-4 p-4">
          <Field label="JOB TITLE"><input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="e.g. Rake the leaves" className="gd-input" /></Field>

          <div>
            <label className="gd-label">CATEGORY</label>
            <div className="flex flex-wrap gap-2">
              {categories.filter((c) => c !== "All").map((c) => (
                <button key={c} onClick={() => setForm({ ...form, category: c })} className="rounded-full px-3 py-1.5 text-xs font-bold transition-all"
                  style={{ background: form.category === c ? "#3b57c9" : "#eef1fb", color: form.category === c ? "#fff" : "#5b648a" }}>{c}</button>
              ))}
            </div>
          </div>

          <div className="flex gap-3">
            <Field label="PAY ($)" wide><input value={form.pay} onChange={(e) => setForm({ ...form, pay: e.target.value.replace(/[^0-9]/g, "") })} placeholder="25" inputMode="numeric" className="gd-input" /></Field>
            <Field label="DURATION" wide><input value={form.duration} onChange={(e) => setForm({ ...form, duration: e.target.value })} placeholder="1 hr" className="gd-input" /></Field>
          </div>

          <Field label="SCHEDULE (DATE & TIME)"><input value={form.schedule} onChange={(e) => setForm({ ...form, schedule: e.target.value })} placeholder="Sat, Jun 21 · 10:00 AM" className="gd-input" /></Field>
          <Field label="DESCRIPTION"><textarea value={form.desc} onChange={(e) => setForm({ ...form, desc: e.target.value })} rows={3} placeholder="What needs to be done?" className="gd-input resize-none" /></Field>
        </div>
      </div>

      <div className="absolute inset-x-0 bottom-0 bg-white/90 px-5 pb-6 pt-4 backdrop-blur" style={{ boxShadow: "0 -8px 24px rgba(31,42,82,.08)" }}>
        <button onClick={submit} disabled={!canPost} className="w-full rounded-2xl py-4 text-base font-extrabold text-white transition-all"
          style={{ background: canPost ? "linear-gradient(180deg,#ffa63a,#f5911e)" : "#d3b78f", boxShadow: canPost ? "0 12px 24px rgba(245,145,30,.35)" : "none" }}>
          Post Job to Neighborhood
        </button>
      </div>

      {posted && (
        <div className="absolute inset-0 z-50 flex items-end bg-black/40">
          <div className="gd-enter relative w-full rounded-t-[28px] bg-white p-6 pb-8 text-center">
            <button onClick={() => navigate("/neighbor")} className="absolute right-5 top-5 text-[#a3abc9]"><X size={20} /></button>
            <div className="mx-auto mb-4 h-1.5 w-12 rounded-full bg-[#e6e9f5]" />
            <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-[#eaf6ea]"><CheckCircle2 size={34} className="text-[#4fae3f]" /></div>
            <h3 className="mt-3 text-xl font-black text-[#1f2a52]">Job Posted!</h3>
            <p className="mt-1 text-sm text-[#5b648a]"><b>{form.title}</b> is now live for background-checked kids in your neighborhood to accept.</p>
            <button onClick={() => navigate("/neighbor")} className="gd-orange-btn mt-5 w-full rounded-2xl py-3.5 font-extrabold">View My Posted Jobs</button>
          </div>
        </div>
      )}
    </div>
  );
}

function Field({ label, children, wide }) {
  return (
    <div className={wide ? "flex-1" : ""}>
      <label className="gd-label">{label}</label>
      {children}
    </div>
  );
}
